module.exports = __webpack_public_path__ + "img/menu_btn.6f90c8c4.png";